var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"load":function($event){return _vm.newMobil()}}},[_c('transition',{attrs:{"mode":"out-in","name":"el-fade-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }